<div class="w-full max-w-5xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
        <h2>Auðkenningarbeiðnir</h2>
        <p>Hér færð þú yfirlit yfir framkvæmdar auðkenningarbeiðnir</p>
    </div>

    <span class="separator-line block mb-[20px]"></span>

    <div>
        <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-4 pr-6 border-b">
            <!-- Main actions -->
            <div class="flex items-center">
                <!-- Search -->
                <div class="flex-auto">
                    <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input matInput placeholder="Leita" (keyup)="searchFilter($event.target.value)" />
                    </mat-form-field>
                    @if (loaded) {
                        <div class="mr-0.5 float-right mt-0.5 font-medium text-secondary">
                            @if (displayedData.filteredData.length > 0) {
                                {{ displayedData.filteredData.length }}
                            }
                            {{
                                displayedData.filteredData.length
                                    | i18nPlural
                                        : {
                                              '=0': 'Engar beiðnir fundust',
                                              '=1': 'beiðni fannst',
                                              other: 'beiðnir fundust',
                                          }
                            }}
                        </div>
                    }
                </div>
            </div>
        </div>

        <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="displayedData" class="w-[100%]">
            <ng-container matColumnDef="audkenningarLogsId">
                <th mat-sort-header="audkenningarLogsId" mat-header-cell *matHeaderCellDef>Auðkenni</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.audkenningarLogsId }}
                </td>
            </ng-container>
            <ng-container matColumnDef="authMessage">
                <th mat-sort-header="authMessage" mat-header-cell *matHeaderCellDef>Skilaboð vegna auðkenningar</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.authMessage }}
                </td>
            </ng-container>
            <ng-container matColumnDef="authMessageExtra">
                <th mat-sort-header="authMessageExtra" mat-header-cell *matHeaderCellDef>Viðbótarupplýsingar</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.authMessageExtra }}
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-sort-header="name" mat-header-cell *matHeaderCellDef>Nafn auðkennanda</th>
                <td mat-cell *matCellDef="let element">{{ element?.name }}</td>
            </ng-container>
            <ng-container matColumnDef="userId">
                <th mat-sort-header="userId" mat-header-cell *matHeaderCellDef>Starfsmaður</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.userId }}
                </td>
            </ng-container>
            <ng-container matColumnDef="userEmail">
                <th mat-sort-header="userEmail" mat-header-cell *matHeaderCellDef>Netfang starfsmanns</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.userEmail }}
                </td>
            </ng-container>
            <ng-container matColumnDef="timeStamp">
                <th mat-sort-header="timeStamp" mat-header-cell *matHeaderCellDef>Tímastimpill</th>
                <td mat-cell *matCellDef="let element">
                    <span [matTooltip]="'Skráð þann'">{{ formatDate(element.timeStamp) }}</span>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="orgRequestsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: orgRequestsColumns"></tr>
            <tr class="mat-row" *matNoDataRow>
                @if (loaded) {
                    <div class="flex items-center justify-between">
                        <span>
                            <div class="mt-2 ml-2 font-medium text-secondary mt-[5px]">Engar beiðnir fundust</div>
                        </span>
                    </div>
                }
            </tr>
        </table>
        <mat-paginator #tablePaginator class="justify-end" showFirstLastButtons [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
        </mat-paginator>
    </div>
</div>
